$( ".fullwidthcta-link .button" ).on( "mouseenter focusin", function() {
    $(this).closest('.fullwidthcta').addClass('__hovering');
});
$( ".fullwidthcta-link .button" ).on( "mouseout focusout", function() {
    $(this).closest('.fullwidthcta').removeClass('__hovering');
});